import ReduxProvider from '@/components/ReduxProvider/ReduxProvider';

export default ReduxProvider;
